// removed by extract-text-webpack-plugin
module.exports = {"pagination":"_3Nu_GOJM15p1F9ML6yiYwd","container":"_8f4XVvvLoRidV0d11Svdt","column":"Jd9xuhc4p4szbt31hJzcM","paginationTotals":"_5ASHWF0D3iAFl-MctYCWf","paginationLinksList":"NduUU9HBiNNtVnrgBubB4","paginationArrow":"_2HQ6kFNuG_6COwMKQaujKy","paginationEllipsis":"uL8JrA17v0WSg5APwNFON","paginationPage":"_3B6k3OYqdrSVQCY38p28Eq","paginationPageActive":"sdjvNFOs5MTwXiNhuo4GU"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/actions/Pagination.css
// module id = 301
// module chunks = 0